<template>
  <b-container class="main-area">
    <b-row align-h="around">
      <b-col lg="2">
        <sidebar></sidebar>
      </b-col>
      <b-col lg="10">
        <b-container>
          <transition name="fade">
            <router-view></router-view>
          </transition>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Sidebar from '@/components/Sidebar'
export default {
  name: 'profile',
  components: { Sidebar }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// Profile.vue?573bd991